import React, { FC } from 'react';
import classNames from 'classnames';

import { useTranslation } from 'app/lang';

import { ScoreboardCell } from '../ScoreboardCell';

import dictionary from './Soccer.dictionary.json';

import styles from '../../ScoreboardCells.module.scss';

const CARDS_TITLE = { yellow: dictionary.yellowCards, red: dictionary.redCards };

type PenaltyCardProps = {
  cardAmount?: number;
  kind: 'yellow' | 'red';
};

const PenaltyCard: FC<PenaltyCardProps> = ({ cardAmount, kind }) => {
  const { t } = useTranslation();

  return (
    <ScoreboardCell className={classNames(styles.soccerCard, styles[kind])}>
      <span>{t(CARDS_TITLE[kind])}</span>
      {cardAmount}
    </ScoreboardCell>
  );
};

export default PenaltyCard;
